import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import completeImg from '../images/Complete.png'
import pendingImg from '../images/Pending.png'
 

const CusAppDtlsPreviewTitle = (props) =>{
    const {id, name, showEdit,doneMyInfo,isSoleProps } = props;

    const clickEdit = () => {
 
        props.onEdit(id);
    }

    return(
    <FieldWrapper>
        <div className="row around-xs elementVisible">
        {!isSoleProps?
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign:'center'}}>
            <div style={{width:'95%',float:'left'}}>
                <legend id={id}>{name}&nbsp;
                 {doneMyInfo? <img width="20" height="20" src={completeImg} /> : <img src={pendingImg}  width="20" height="20" />}  
                </legend>
            </div>
            {showEdit &&
            <div style={{width:'5%',float:'left',paddingTop:'5px'}}>
                <span className="k-icon k-i-edit" onClick={clickEdit} ></span>
            </div>}
            </div>:

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign:'center'}}>
            <div style={{width:'95%',float:'left'}}>
                <legend id={id}>{name} 
                </legend>
            
            </div>
            {showEdit &&
                <div style={{width:'5%',float:'left',paddingTop:'5px'}}>
                <span className="k-icon k-i-edit" onClick={clickEdit} ></span>
            </div>  }
            </div>}
      
        </div>
    </FieldWrapper>
    )
}

export default CusAppDtlsPreviewTitle;